<app-sidebar
  layoutVariant="consumer"
  [menuItems]="menuItems"
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Consumer"
>
</app-sidebar>


